import { Box, Stack } from '@mui/material';

import { useTheme } from 'src/provider/ThemeCustomizationProvider';
import { combineHexAndOpacity } from 'src/utils/helpers';

import { ThemePreviewLayout } from './ThemePreviewLayout';

export function ReferralPagePreview() {
  const { theme } = useTheme();

  const containerColor = combineHexAndOpacity(theme.theme.container.color, theme.theme.container.colorOpacity);
  const primaryColor = combineHexAndOpacity(
    theme.theme.bgColorButton.primary,
    theme.theme.bgColorButton.primaryOpacity,
  );
  const headerRowColor = combineHexAndOpacity(theme.theme.headerRow.color, theme.theme.headerRow.colorOpacity);

  return (
    <ThemePreviewLayout theme={theme}>
      <Box width={'100%'} padding={'5.3px 10px'} marginTop={'11.02px'}>
        <Stack
          justifyContent={'end'}
          width={'100%'}
          height={'55.3px'}
          padding={'8.16px'}
          borderRadius={'2.45px'}
          bgcolor={containerColor}
          sx={{
            backdropFilter: 'blur(2.24px)',
          }}>
          <Stack direction={'row'} spacing={'4.69px'} alignItems={'center'}>
            <Box width={'95.9px'} height={'13.26px'} borderRadius={'2.44px'} bgcolor={containerColor} />
            <Box width={'35.9px'} height={'13.26px'} borderRadius={'0.81px'} bgcolor={containerColor} />
            <Box width={'35.9px'} height={'13.26px'} borderRadius={'0.81px'} bgcolor={primaryColor} />
          </Stack>
        </Stack>
        <Stack direction={'row'} spacing={'8.37px'} alignItems={'center'} marginTop={'14.69px'}>
          <Box width={'62.24px'} height={'29.17px'} borderRadius={'2.44px'} bgcolor={containerColor} />
          <Box width={'62.24px'} height={'29.17px'} borderRadius={'2.44px'} bgcolor={containerColor} />
        </Stack>
        <Box
          width={'100%'}
          height={'13.26px'}
          bgcolor={headerRowColor}
          marginTop={'14.69px'}
          borderRadius={'2.44px'}></Box>
        <Box width={'100%'} height={'1px'} bgcolor={containerColor} marginTop={'10.82px'}></Box>
        <Box width={'100%'} height={'1px'} bgcolor={containerColor} marginTop={'10.82px'} marginBottom={'7px'}></Box>
      </Box>
    </ThemePreviewLayout>
  );
}
